(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-navigation"]) return;
  try {
    
  class PWNavigation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialogs = Array.from(this.querySelectorAll('[data-pw-dialog]'));
      this.triggers = Array.from(document.querySelectorAll('[data-pw-open-categories], [data-pw-open-trends]'));
      this.triggers.forEach((trigger) => {
        const name = trigger.hasAttribute('data-pw-open-categories') ? 'categories' : 'trends';
        const dialog = this.dialogs.find((item) => item.dataset.pwDialog === name);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.setAttribute('aria-expanded', 'false');
      });
      document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const trigger = event.target.closest('[data-pw-open-categories], [data-pw-open-trends]');
        if (!trigger) return;
        const name = trigger.hasAttribute('data-pw-open-categories') ? 'categories' : 'trends';
        const dialog = this.dialogs.find((item) => item.dataset.pwDialog === name);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        this.dialogs.forEach((item) => { if (item.open) item.close(); });
        this.returnFocus = trigger;
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.dialogs.forEach((dialog) => {
        dialog.querySelector('[data-pw-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, options);
      });
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const selectTab = (tab, focus = false) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab), options);
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          selectTab(tabs[next], true);
        }, options);
      });
      document.addEventListener('shopify:cart:lines-update', (event) => {
        event.promise?.then(({ cart, detail }) => {
          const count = cart?.totalQuantity ?? detail?.itemCount;
          if (Number.isFinite(count)) this.updateCartCount(count);
        }).catch(() => {});
      }, options);
      window.addEventListener('pageshow', () => {
        this.dialogs.forEach((dialog) => { if (dialog.open) dialog.close(); });
        const nativeCount = document.querySelector('cart-icon [ref="cartBubbleCount"]');
        const count = Number.parseInt(nativeCount?.textContent, 10);
        if (Number.isFinite(count)) this.updateCartCount(count);
      }, options);
    }
    updateCartCount(count) {
      const badge = this.querySelector('[data-pw-cart-count]');
      const description = this.querySelector('[data-pw-cart-description]');
      if (badge) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count === 0;
      }
      if (description) description.textContent = `${description.dataset.label}: ${count}`;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.dialogs?.forEach((dialog) => { if (dialog.open) dialog.close(); });
    }
  }
  if (!customElements.get('pw-navigation')) customElements.define('pw-navigation', PWNavigation);

  } catch(e) { console.error(e); }
})();
})();
